// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__yCZHQ","fullSize":"Loader_fullSize___ZQ2T","inbutton":"Loader_inbutton__2jjfA"};